import 'bootstrap/dist/css/bootstrap.min.css';  // Importa Bootstrap CSS
import './assets/css/register.css';  // Estilos específicos para la página de registro
import './assets/vendor/bootstrap-icons/bootstrap-icons.css';  // Iconos de Bootstrap
import './assets/vendor/boxicons/css/boxicons.min.css';  // Boxicons
import './assets/vendor/quill/quill.snow.css';  // Quill CSS (si lo usas)
import './assets/vendor/remixicon/remixicon.css';  // Remix Icon CSS
import 'bootstrap/dist/js/bootstrap.bundle.js'
import React from 'react';
import ReactDOM from 'react-dom/client';  // Cambia la importación aquí
import App from './App';

window.addEventListener('unhandledrejection', event => {
    if (event.reason && typeof event.reason === 'string' &&
        event.reason.includes('A listener indicated an asynchronous response')) {
        event.preventDefault();
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);